// extracted by mini-css-extract-plugin
export default {"englishDocks":"english-docks_englishDocks__iroSh"};